import styled from 'styled-components';

export const TitleStyled = styled.h4`
  margin: 0;
  color: ${(props) => props.theme.palette.primary.main};
  font-size: 24px;
  line-height: 40px;
`;

export const TextStyled = styled.p`
  color: ${(props) => props.theme.palette.secondary.contrastText};
  font-size: 14px;
  line-height: 24px;
  margin: 0 0 12px 0;
`;

export const WrapperStyled = styled.section`
  display: flex;
  justify-content: space-between;
`;
